import { RaceFinishedEvent } from "../types/Racing/RaceFinishedEvent";

export const parseRaceFinishedEvent = (event: any): RaceFinishedEvent | null => {
  const raceId = Number(event?.raceId ?? event?.id);
  if (!Number.isSafeInteger(raceId) || raceId < 0) return null;

  return {
    raceId,
    winner: event.winner,
    creator: event.creator,
    opponent: event.opponent,
    result: Number(event.result),
    winnerCashProfit: Number(event.winnerCashProfit),
    creatorCarId: Number(event.creatorCarId),
    opponentCarId: Number(event.opponentCarId),
    creatorHealthLost: Number(event.creatorHealthLost),
    opponentHealthLost: Number(event.opponentHealthLost),
    timestamp: Number(event.timestamp),
    creatorDetail: event.CreatorDetail,
    opponentDetail: event.OpponentDetail,
    creatorCarDetail: event.CreatorCarDetail,
    opponentCarDetail: event.OpponentCarDetail,
    cityId: Number(event.cityId),
    cashAmount: Number(event.cashAmount),
    prizeType: event.prizeType,
  } as RaceFinishedEvent;
};

export const parseRaceCancelledEvent = (event: any) => {
  return {
    raceId: Number(event.raceId),
  };
};

export const parseRaceCreatedEvent = (event: any) => {
  return {
    raceId: Number(event.id),
    cityId: Number(event.cityId),
    creator: event.creator,
    creatorCarId: Number(event.creatorCarId),
    betAmount: Number(event.cashAmount),
    prizeType: event.prizeType,
    timestamp: Number(event.timestamp),
    creatorDetail: event.CreatorDetail
      ? {
          id: Number(event.CreatorDetail.id),
          name: event.CreatorDetail.name,
        }
      : null,
    creatorCarDetail: event.CreatorCarDetail
      ? {
          id: Number(event.CreatorCarDetail.id),
          carType: Number(event.CreatorCarDetail.carType),
          damagePercent: Number(event.CreatorCarDetail.damagePercent),
        }
      : null,
  };
};
